import React from 'react';
import {Grid, IconButton, InputAdornment, styled, Typography} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const AlignCenterGrid = styled(Grid)(() => ({
  alignSelf: 'center',
}));

const AlignCenterHideOnSmallScreen = styled(AlignCenterGrid)(({theme}) => ({
  // Hide on small screens below the medium breakpoint
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));

interface PlacesAutocompleteInputAdornmentEndProps {
  searchValue: string;
  showFilters?: boolean;
  onCancelIconClick: () => void;
  onFiltersIconClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  compact?: boolean;
}

const PlacesAutocompleteInputAdornmentEnd = (props: PlacesAutocompleteInputAdornmentEndProps) => {
  const {searchValue, showFilters, onCancelIconClick, onFiltersIconClick, compact} = props;

  // Search page: just the clear button; the filter chips sit right under the field.
  if (compact) {
    return searchValue ? <InputAdornment position={'end'}>
      <IconButton size={'small'} aria-label={'Clear location'} onClick={onCancelIconClick}>
        <CloseIcon fontSize={'small'}/>
      </IconButton>
    </InputAdornment> : null;
  }

  return <InputAdornment position={'end'}>
    {
      searchValue && <Grid container direction={'row'} wrap={'nowrap'} justifyContent={'center'} spacing={1}>
          <AlignCenterHideOnSmallScreen item>
            <Typography variant={'overline'}>Hit Enter to Search</Typography>
          </AlignCenterHideOnSmallScreen>
          <AlignCenterGrid item>
            <KeyboardReturnIcon fontSize={'small'} color={'primary'}/>
          </AlignCenterGrid>
        {
          !showFilters && <AlignCenterGrid item>
            <IconButton onClick={onFiltersIconClick} color={'primary'}>
              <ArrowDropDownIcon fontSize={'large'} />
            </IconButton>
          </AlignCenterGrid> || <AlignCenterGrid item>
            <IconButton onClick={onFiltersIconClick} color={'primary'}>
              <ArrowDropUpIcon fontSize={'large'} />
            </IconButton>
          </AlignCenterGrid>
        }
        <AlignCenterGrid item>
          <IconButton onClick={onCancelIconClick} color={'primary'}>
            <CancelIcon fontSize='small' />
          </IconButton>
        </AlignCenterGrid>
      </Grid>
    }
  </InputAdornment>
}

export default PlacesAutocompleteInputAdornmentEnd;
